module.exports = __webpack_public_path__ + "ClientApp/content/Children-pet-loss.jpg";